import { render, staticRenderFns } from "./CreateSignature.vue?vue&type=template&id=db089fd8&scoped=true&"
import script from "./CreateSignature.vue?vue&type=script&lang=ts&"
export * from "./CreateSignature.vue?vue&type=script&lang=ts&"
import style0 from "./CreateSignature.vue?vue&type=style&index=0&id=db089fd8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db089fd8",
  null
  
)

export default component.exports